import { Injectable } from '@angular/core';
import { CatalogoProtocolo } from '../../model/catalogo.model';
import { BehaviorSubject } from 'rxjs';
import { CatalogoSvgApiService } from '../api/catalogo-svg-api.service';

@Injectable({
  providedIn: 'root'
})
export class CatalogoSvgStoreService {
  private catalogoProtocoloSubject = new BehaviorSubject<CatalogoProtocolo>(null);
  catalogoProtocoloSubject$ = this.catalogoProtocoloSubject.asObservable();

  constructor(private catalogoService: CatalogoSvgApiService) { }

  getCatalogoProtocolo(codProtocolo: number, usuario: string): void {
    this.catalogoService.getCatalogoProtocolo(codProtocolo, usuario).subscribe({
      next: (catalogo) => {
        this.catalogoProtocoloSubject.next(catalogo);
      },
      error: (err) => console.error('Error recuperando catalogo:', err),
    });
  }

  limpiarCatalogoProtocolo(): void {
    this.catalogoProtocoloSubject.next(null);
  }
}
